import { render, staticRenderFns } from "./EpiSuiteCardTooltip.vue?vue&type=template&id=27f3ce30"
import script from "./EpiSuiteCardTooltip.vue?vue&type=script&lang=js"
export * from "./EpiSuiteCardTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports